import { gql } from "apollo-boost"

export const CREATE_ACTIVITIES = gql`
  mutation createActivities ($activities: [CreateActivityInput!]!) {
    createActivities(activities: $activities){
      id
    }
  }
`
